import { Route } from '@angular/router';
import packageJson from '@vmspdb/package-json';
import { authGuardCanActivate } from '@vmspdb/ui/common';
import { FullLayoutComponent, LayoutRoutes } from '@vmspdb/ui/layouts';
import { GlobalTimeTrackingHeaderComponent } from './global/components/time-tracking-header/global-time-tracking-header.component';
import { settingsLoadGuard } from './guards/settings-load-guard';

export const appRoutes: Route[] = [
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [authGuardCanActivate],
    data: {
      header: GlobalTimeTrackingHeaderComponent,
      version: packageJson.version,
    },
    children: [
      {
        path: 'admin',
        title: 'Admin',
        canActivate: [settingsLoadGuard],
        loadChildren: () =>
          import('./modules/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'powerhouse',
        title: 'Powerhouse',
        canActivate: [settingsLoadGuard],
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: 'management',
        title: 'Management',
        loadChildren: () =>
          import('./modules/management/management.module').then(
            (m) => m.ManagementModule,
          ),
      },
      {
        path: 'projects',
        title: 'Projects',
        canActivate: [settingsLoadGuard],
        loadChildren: () =>
          import('./modules/projects/projects.module').then(
            (m) => m.ProjectsModule,
          ),
      },
      {
        path: 'permits',
        title: 'Permits',
        canActivate: [settingsLoadGuard],
        loadChildren: () =>
          import('./modules/permits/permits.module').then(
            (m) => m.PermitsModule,
          ),
      },
      {
        path: 'surveying',
        title: 'Surveying',
        canActivate: [settingsLoadGuard],
        loadChildren: () =>
          import('./modules/surveying/surveying.module').then(
            (m) => m.SurveyingModule,
          ),
      },
      {
        path: 'time-tracking',
        title: 'Time Tracking',
        canActivate: [settingsLoadGuard],
        loadChildren: () =>
          import('./modules/time-tracking/time-tracking.module').then(
            (m) => m.TimeTrackingModule,
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'powerhouse',
      },
      {
        path: 'dashboard',
        pathMatch: 'full',
        redirectTo: 'powerhouse',
      },
      // Header extra outlets
      {
        path: '',
        pathMatch: 'full',
        component: GlobalTimeTrackingHeaderComponent,
        outlet: LayoutRoutes.Header,
      },
      {
        path: '**',
        component: GlobalTimeTrackingHeaderComponent,
        outlet: LayoutRoutes.Header,
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
];
